import axios, { getData } from "lib/axios";
import { useQuery, useMutation, useQueryClient } from "react-query";

export const useGetHoliday = () =>
  useQuery(["holiday"], async () => {
    const res = await axios.get(`/admin/holiday`).then(getData);
    return res.data;
  });

export const useUpdatePublicHoliday = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async () => {
      const res = await axios.post(`/admin/public-holiday`);
      return res;
    },
    {
      onSuccess: () => {
        // invalidate and refetch
        queryClient.invalidateQueries("holiday");
      },
    }
  );
};

// This is also use to mass update public holiday
export const usePostNewCustomHoliday = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (postData) => {
      const res = await axios.post(`/admin/holiday`, postData);
      return res;
    },
    {
      onSuccess: () => {
        // invalidate and refetch
        queryClient.invalidateQueries("holiday");
        queryClient.invalidateQueries("disabled-date");
      },
    }
  );
};
export const useDeleteCustomHoliday = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (holidayId) => {
      const res = await axios.delete(`/admin/holiday/${holidayId}`);
      return res;
    },
    {
      onSuccess: () => {
        // invalidate and refetch
        queryClient.invalidateQueries("holiday");
        queryClient.invalidateQueries("disabled-date");
      },
    }
  );
};
export const useUpdateCustomHoliday = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const { postData, id } = data;
      const res = await axios.put(`/admin/holiday/${id}`, postData);
      return res;
    },
    {
      onSuccess: () => {
        // invalidate and refetch
        queryClient.invalidateQueries("holiday");
        queryClient.invalidateQueries("disabled-date");
      },
    }
  );
};
